import type { IFilter } from '@models/Filter'

import { request } from '../../../gateways/api'
import type {
  ContractinstellingenSearch,
  ContractinstellingenSearchFilters,
} from '../types/ContractinstellingenSearch'

export const fetchTemplates = async (
  filters: ContractinstellingenSearchFilters,
) => {
  const result = await request<ContractinstellingenSearch['data']>({
    url: '/rest/template/search',
    method: 'POST',
    data: {
      filters: createFilters(filters),
      skip: 0,
      limit: 1000,
    },
  })

  return result
}

export const initialState: ContractinstellingenSearch = {
  data: { bijlageTemplates: [], activiteitTemplates: [] },
  query: {
    filters: {
      combi: null,
    },
  },
}

export const createFilters = ({ combi }: ContractinstellingenSearchFilters) => {
  const filters: IFilter[] = [
    { name: 'projectType', value: 'Aanvraag', operator: 'eq' },
  ]

  if (combi)
    filters.push({
      name: 'combi',
      value: combi,
      operator: 'eq',
    })

  return filters
}
